export const publicDashboards = [
    {
        _id: "LW7bvdFPDAyYQ42ip",
        companiesCount: 24165,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        new: true,
        name: "Resultados Bruto (Financeiro)",
        description:
            "O Dashboard de Resultado é aquele que vai detalhar pra você os resultados da empresa e a sua sazonalidade. Agora separando Custos e Despesas, para que você saiba onde agir. Na aba de Resultados é onde também temos informações imprescindíveis, como a Margem de Contribuição e o Ponto de Equilíbrio, essenciais para garantir decisões assertivas para o seu negócio e uma análise obrigatória caso sua empresa não esteja lucrando.",
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["RFfwFyrewkcFPUnei", "raExJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["cfExJxdEoqtnFBw2n", "rafxJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["DfExJxdEoqtnFBw2n", "potEJxdEoqtnFBw2n"]
            }
        ],
        sources: ["financial"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 10,
        version: 0,
        name_nd: "RESULTADOS BRUTO (FINANCEIROS)",
        public: true,
        createdAt: new Date("2019-07-08T11:45:28.147+0000"),
        createdBy: "0",
        updatedAt: new Date("2020-11-13T23:57:19.215+0000"),
        updatedBy: "0"
    },
    {
        companiesCount: 22859,
        companyId: "EMPRESA_NUCONT",
        new: true,
        hidden: false,
        name: "Resumo Bruto (Financeiro)",
        description:
            "O Dashboard Financeiro é uma ótima forma de iniciarmos o acompanhamento da saúde da empresa, quando por algum motivo não conseguimos ainda um acompanhamento completo através do Dashboard Contábil. Nele temos a possibilidade de gerar indicadores de saúde financeira a partir das demonstrações de resultados ou integração com o sistema financeiro. A partir dele já conseguimos diagnósticos essenciais para a saúde do negócio, o que nos ajuda a tomar melhores decisões e potencializar nossos resultados.",
        sections: [
            {
                height: 50,
                template: "1,1,1",
                visualizationsIds: [
                    "FafwFyrewkcDPSnei",
                    "fffwFyrfwkcDPSneg",
                    "FLExJxdEoqtnFBw2n"
                ]
            },
            {
                height: 75,
                template: "1,1",
                visualizationsIds: ["fiExJxdEoqtnFBw2n", "EaExJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["PcCxJxdEoqtnFBw2n", "PdexJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["inExJxdEoqtnFBw2n", "fiEaJxdEoqtnFBw2n"]
            }
        ],
        sources: ["financial"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 9,
        version: 0,
        name_nd: "RESUMO BRUTO (FINANCEIRO)",
        public: true,
        createdAt: new Date("2019-07-08T11:43:31.854Z"),
        createdBy: "0",
        updatedAt: new Date("2020-08-21T20:02:02.330Z"),
        updatedBy: "0"
    },

    {
        companiesCount: 24744,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Estrutural",
        description:
            "O Dashboard Estrutural é aquele que vamos recorrer para fazer o diagnóstico da saúde do endividamento e da estrutra da obtenção de recursos da empresa de forma mais detalhada. É nele que vamos fazer o diagnóstico de Excesso de Endividamento e o seu grau de risco. Junto com outros indicadores que irão explicar a origem dessa doença.",
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["qeExJxdEoqtnFBw2n", "tAExJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["zAExJxdEoqtnFBw2n", "olExJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1,1",
                visualizationsIds: [
                    "mnUtefvEoqtnFBw2nRecurso",
                    "coExJxdEoqtnFBw2n",
                    "mondxdEdqsnvBw4n"
                ]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 6,
        version: 0,
        name_nd: "ESTRUTURAL",
        public: true,
        createdAt: new Date("2019-07-04T11:56:20.838Z"),
        createdBy: "0",
        updatedAt: new Date("2020-08-21T20:02:08.031Z"),
        updatedBy: "0",
        new: true
    },

    {
        companiesCount: 24734,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Capital de Giro",
        description:
            "O Dashboard de Capital de Giro é um dos mais importantes de todo o Nucont. Nos tráz informações imprescindíveis para a análise da saúde financeira da empresa e diagnósticos que não conseguimos em nenhum outro lugar, se não na Contabilidade. É aqui que poderemos fazer o Enquadramento de Fleuriet do empreendimento, fazer a gestão dos Prazos da Operação e encontrar pontos de melhoria efetivos para sua saúde. É a aba responsável pelo Diagnóstico de Insolvência Financeira, junto com outros indicadores.",
        sections: [
            {
                height: 100,
                template: "1",
                visualizationsIds: ["ldfmdEoqtnFBw2nPRAZO2"]
            },
            {
                height: 66,
                template: "1",
                visualizationsIds: ["yAExJxdEoqtnFBw2n"]
            },
            {
                height: 66,
                template: "1",
                visualizationsIds: ["sdnxdEoqtnFBw2n"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 4,
        version: 0,
        name_nd: "CAPITAL DE GIRO",
        public: true,
        createdAt: new Date("2019-07-04T11:56:20.816Z"),
        createdBy: "0",
        updatedAt: new Date("2020-08-21T20:02:07.161Z"),
        updatedBy: "0",
        new: true
    },

    {
        companiesCount: 24743,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Resultados",
        description:
            "O Dashboard de Resultado é aquele que vai detalhar pra você os resultados da empresa e a sua sazonalidade. Agora separando Custos e Despesas, para que você saiba onde agir. Na aba de Resultados é onde também temos informações imprescindíveis, como o Markup e a Margem de Contribuição, essenciais para diagnósticos como Undertrading e Overtrading e para garantir uma precificação saudável para o seu negócio. É uma análise obrigatória caso sua empresa não esteja lucrando.",
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["RLfwFyrewkcFPUnei", "ekExJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["eAExJxdEoqtnFBw2n", "AcuExJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["dMixJAdEo4tn6Bw2n", "iAExJxdEoqtnFBw2n"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 2,
        version: 0,
        name_nd: "RESULTADOS",
        public: true,
        createdAt: new Date("2019-07-04T11:56:20.798Z"),
        createdBy: "0",
        updatedAt: new Date("2020-08-21T20:02:05.559Z"),
        updatedBy: "0",
        new: true
    },

    {
        companiesCount: 24761,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Avaliação",
        description:
            "O Dashboard de Avaliação é o que vai nos trazer informações sobre a Liquidez da empresa e sua capacidade de retorno. É o panorâma final do negócio, influenciado por todas as decisões e resultados provindos de todos os setores. Traz indicadores como o EBITDA, a Imobilização do Patrimônio Líquido, quatro indicadores diferentes de Liquidez e como que isso interfere no valor do negócio e na sua rentabilidade.",
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["mondxdEdqsnvBw4n", "sAExJxdEoqtnFBw2n22"]
            },
            {
                height: 100,
                template: "1",
                visualizationsIds: ["bdyshJxdEoqtnFBw2n2"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["uAExJxdEoqtnFBw2n", "olExJxdEoqtnFBw2n"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 5,
        version: 0,
        name_nd: "AVALIACAO",
        public: true,
        createdAt: new Date("2019-07-04T11:56:20.829Z"),
        createdBy: "0",
        updatedAt: new Date("2020-08-21T20:02:07.967Z"),
        updatedBy: "0",
        new: true
    },

    {
        companiesCount: 24735,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Resumo",
        description:
            "O Dashboard de Resumo é onde temos um panorama geral sobre a saúde da empresa. Nele temos o acompanhamento dos principais indicadores responsáveis pela avaliação de saúde e aqueles que mais interessam os empresários na hora de analisar suas próprias empresas. Indicadores como Lucratividade, EBITDA, a Capacidade de Quitar Obrigações e o Ciclo Financeiro nos permite, já na primeira aba do dashboard, identificar os principais pontos de atenção da empresa.",
        sections: [
            {
                height: 50,
                template: "1,1,1",
                visualizationsIds: [
                    "CZfwFyrewkcDPSnei",
                    "CZfwFyrewkcDPSacumu",
                    "wAExJxdEoqtnFBw2n"
                ]
            },
            {
                height: 75,
                template: "1,1",
                visualizationsIds: ["nnvnJxdEoqtnFBw2n", "vardJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1,1",
                visualizationsIds: [
                    "jAExJxdEoqtnFBw2n",
                    "kAExJxdEoqtnFBw2n",
                    "ybtxdEoqtnFBw2n"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["jxnsdcjxdEoqtnFBw2n", "mondxdEdqsnvBw4n"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 1,
        version: 0,
        name_nd: "RESUMO",
        public: true,
        createdAt: new Date("2019-07-04T11:56:20.790Z"),
        createdBy: "0",
        updatedAt: new Date("2020-08-21T20:02:05.486Z"),
        updatedBy: "0",
        new: true
    },

    {
        companiesCount: 24770,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Folha",
        description:
            "O Dashboard de Folha é o que vai nos auxiliar na gestão do pessoal da sua empresa. É a análise que vamos recorrer para identificarmos se os gastos com os colaboradores estão atrapalhando os resultados da empresa. A partir dele é possível entender o quão produtiva é a sua equipe e diagnosticar, em conjunto com outros indicadores, se a sua Folha está inchada ou não.",
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["bbbxJxdEoqtnFBw2n", "dAExJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["bsrJxdEoqtnFBw2n", "vsrJxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["uqyxJxdEoqtnFBw2n2"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 3,
        version: 0,
        name_nd: "FOLHA",
        public: true,
        createdAt: new Date("2019-07-04T11:56:20.807Z"),
        createdBy: "0",
        updatedAt: new Date("2020-08-21T20:02:06.361Z"),
        updatedBy: "0",
        new: true
    },
    {
        _id: "balanceidTHahMb3M4F6",
        companiesCount: 100,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Balanço",
        sources: ["accounting"],
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "ClireuwFyrewkcFPUnei",
                    "aTireuwFyrewkcFPUnei"
                ]
            },

            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "ativouwFyrewkcFPUnei",
                    "caxeeqeuwFyrewkcFPUnei"
                ]
            },

            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["estuwFyrewkcFPUnei", "fOuwFyrewkcFPUnei"]
            },

            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["imobiuwFyrewkcFPUnei", "jeuwFyrewkcFPUnei"]
            },

            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "musreuwFyrewkcFPUnei",
                    "mutoebiuwFyrewkcFPUnei"
                ]
            },

            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "oNaoutraY5CLf7dx2MP8jgs",
                    "oatiieuwFyrewkcFPUnei"
                ]
            },

            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "ouaeeqeuwFyrewkcFPUnei",
                    "outrosaY5CLf7dx2MP8jgs"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "Otf91cb7000959752ad63d61a",
                    "PassiutraY5CLf7dx2MP8jgs"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "adcfi0c7hael65451cd295a5c8",
                    "csC7yCZKjjuPXrwRKov"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "efcB2TFzSjpuNy5r64o",
                    "fapprova5CLf7dx2MP8jgs"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "forpixjC22ouRnZWmpp",
                    "ldf91cb7500959752ad63d622"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "lp91cb7500959752ad63d621",
                    "mtprpYqhCEnGv7aByWv"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "oplcyCZKjjuPXrwRKov",
                    "opncrpYqhCEnGv7aByWv"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "opoYcVkTDygAyhZyihQCu",
                    "pa91cb6f00959752ad63d619"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "passivolro7qlenz0od32f",
                    "pl9uc6dpBYG5ZCsifXN"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "pncprova5CLf7dx2MP8jgs",
                    "pscYqhCEnGv7aByWv"
                ]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["resultuc6dpBYG5ZCsifXN"]
            }
        ]
    },
    {
        _id: "niceidTHahMb3M4F6",
        companiesCount: 100,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "DRE",
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["GLreksz7PROjAcvei", "BRICksz7PROjAcvei"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["ABk7k5w7AARjAcViz", "GLk2k1z7cUSjAcVIZ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["VizExTX6KGf2KFBWQ", "2izeeTbbKGf2KFBWQ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["Viz9x9X9KsssssBWQ", "VbbbbTX66G52KFBWQ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["1234x9X9KsssssBWQ", "wizEeTbAKGf2K87WQ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["VitCksz7PROjAcvei", "AETEeTgAG122K98WQ"]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["5lcFeTgPOmB2K87WQ"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 10,
        version: 0,
        name_nd: "DRE",
        public: true,
        new: true,
        updatedAt: new Date("2020-10-09T14:11:12.566Z"),
        updatedBy: "0"
    },
    {
        _id: "niceidTHahMb3M4F6fin",
        companiesCount: 100,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "DRE Financeiro",
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["GLreksz7PROjAcvei", "BRICksz7PROjAcvei"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["ABk7k5w7AARjAcViz", "GLk2k1z7cUSjAcVIZ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["VizExTX6KGf2KFBWQ", "2izeeTbbKGf2KFBWQ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["Viz9x9X9KsssssBWQ", "VbbbbTX66G52KFBWQ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["1234x9X9KsssssBWQ", "wizEeTbAKGf2K87WQ"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["VitCksz7PROjAcvei", "AETEeTgAG122K98WQ"]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["5lcFeTgPOmB2K87WQ"]
            }
        ],
        sources: ["fin"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        position: 10,
        version: 0,
        name_nd: "DRE",
        public: true,
        new: true,
        updatedAt: new Date("2020-10-09T14:11:12.566Z"),
        updatedBy: "0"
    },
    {
        _id: "amggzMSpdhMb3M4F6",
        companiesCount: 51580.0,
        companyId: "EMPRESA_NUCONT",
        hidden: false,
        name: "Análise Vertical",
        position: 8.0,
        sections: [
            {
                height: 50.0,
                template: "1",
                visualizationsIds: ["AnaL2020oqtnFBw2n"]
            },
            {
                height: 50.0,
                template: "1,1",
                visualizationsIds: ["cusTJxdEoqtnFBw2n", "cusvaxdEoqtnFBw2n"]
            },
            {
                height: 50.0,
                template: "1,1",
                visualizationsIds: ["desvaxdEoqtnFBw2n", "desObxdEoqtnFBw2n"]
            },
            {
                height: 50.0,
                template: "1,1",
                visualizationsIds: ["impbakGZ3mrcpdP6K4", "imSObkreimrcpdP6K4"]
            },
            {
                height: 50.0,
                template: "1",
                visualizationsIds: ["wAExJxdEoqtnFBw2n"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "dCLDdzbP6WDbgP8nC",
            email: "michael.nucont@gmail.com",
            name: "Michael Silva"
        },
        version: 1.0,
        name_nd: "ANALISE VERTICAL",
        feature: "ANALISE VERTICAL",
        public: true,
        new: true,

        updatedBy: "0"
    },

    {
        _id: "b0qu1vcbqnd0qf01qwa5lke",
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        companiesCount: 1,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Resumo Líquido (Financeiro)",
        position: 12,
        sections: [
            {
                height: 50,
                template: "1,1,1",
                visualizationsIds: [
                    "ResultadorewkcDPSnei",
                    "ResultadoACwkcDPSnei",
                    "fkxExJxdEoqtnFBw2n"
                ]
            },
            {
                height: 75,
                template: "1,1",
                visualizationsIds: ["DiswTqbgxv3znpxplsd", "aeCBZkgfdSDmrNLfp"]
            },
            {
                height: 66,
                template: "1,1",
                visualizationsIds: [
                    "pesoxdosdgstostnFBw2n",
                    "raquelxdEoqtnFBw2n"
                ]
            }
        ],
        sources: ["financial"],
        user: {
            _id: "4nrwPrHG8KBvNQWok",
            email: "nahima@nucont.com",
            name: "Nahima",
            sex: "Feminino",
            trail: "Consultoria"
        },
        version: 0,
        name_nd: "RESUMO LIQUIDO (FINANCEIRO)",
        createdAt: new Date("2020-11-30T12:15:46.034+0000"),
        public: true
    },
    {
        _id: "mcw3zf459xl1w763bftzb4",
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        companiesCount: 1,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Resultado Líquido (Financeiro)",
        position: 13,
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "receitaliquidabsv",
                    "fctbef159441ilyrsa2e8"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["joelmamDXAhubDftPc", "RESQACUjH5bNuHLBvE"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["MEJCdEoCELEBw1n", "pntx9di7h7uK2ZbBw"]
            }
        ],
        sources: ["financial"],
        user: {
            _id: "4nrwPrHG8KBvNQWok",
            email: "nahima@nucont.com",
            name: "Nahima",
            sex: "Feminino",
            trail: "Consultoria"
        },
        version: 0,
        name_nd: "RESULTADO LIQUIDO (FINANCEIRO)",
        createdAt: new Date("2020-11-30T12:23:10.154+0000"),
        public: true
    },
    {
        _id: "5fb66e38469f236f34d97976",
        companiesCount: 1,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Monitoramento",
        position: 99,
        sections: [
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fb327a7351ea006a5372",
                    "5fb3fb5d0615fcea587cf97d"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fb71d976e06908c623d7",
                    "5fb3fb81ced31797d999ffc9"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fb4df4121c3473cc825e",
                    "5fb3fb901e5aa6a9d2fbeefa"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fb9e88c89ce6e5071e99",
                    "5fb3fba75fe3bff0f1c741f4"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fbb2baba2f7dfc272d82",
                    "5fb3fbd3ef3b98ad7b9a0291"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fbdc45fb45cc49fd1892",
                    "5fb3fbe7bcacf1ff5324e733"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fbf11e168e69018fafa4",
                    "5fb3fbfcde5c458788156382"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fc1c1593394eba8258a2",
                    "5fb3fc2b072f7a7bba54282e"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fc35324d1b0108e7c0ed",
                    "5fb3fc3d07f0fad6aab361c7"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb6730eb8a3c0ee70996f61",
                    "5fb3fc55c61e466839fe031c"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fc61a11109d54b769ef8",
                    "5fb3fc689f8b502f3d4b666f"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb3fc7e8aaa955d511a1113",
                    "5fb3fc895a3f908936710dae"
                ]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["5fb3fca972c062ce60a93d80"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb805eef226ec2701ccbf79",
                    "5fb81a09377285c1d5103fec"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "5fb8155ba49581446c2ebfe3",
                    "5fb8169c8afd56f77c24a7be"
                ]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["sdnxdEoqtnFBw2n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "gut31pizygkoare1g581fm",
                    "5fb81db6172941ee3633a9c7"
                ]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["mondxdEdqsnvBw4n"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "pxielkqyfkeynk2s1q1vg",
                    "jjysrfhe9fzk2yfm4pt0g"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "q6ntfpnj7rtj60l97ym3",
                    "xr5447jk7xpd216xu619qw"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "aruzmuabm65ryir3csh6j",
                    "nmjfo4hiy155dw9qg7c4y"
                ]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["qwe0vpi2krvikp8b4hgi9"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "mljs02mfaq7xg3jxn553yp",
                    "wwzqb5va0fczv7tna7vyv"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: [
                    "elwoacmojw6zjans4reky",
                    "gba9m3weu2ccvk6o5oio9" //"nds9m3weu2ccvk6o5oio9"
                ]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["7x3p6b1unekawspxw7lifk"]
            },
            {
                height: 50,
                template: "1",
                visualizationsIds: ["gut31pizygkoare1g581fm"]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["mondxdEdqsnvBw4n", "bbbxJxdEoqtnFBw2n"]
            }
        ],
        sources: ["accounting"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        version: 2,
        name_nd: "MONITORAMENTO",
        public: true
    },
    {
        _id: "financial5fb66e38469f236f34d97976",
        companiesCount: 1,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Monitoramento",
        position: 99,
        sections: [],
        sources: ["financial"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        version: 2,
        name_nd: "MONITORAMENTO",
        public: true
    },
    {
        _id: "tax5fb66e38469f236f34d97976",
        companiesCount: 1,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Monitoramento",
        position: 99,
        sections: [],
        sources: ["tax"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        version: 2,
        name_nd: "MONITORAMENTO",
        public: true
    },
    {
        _id: "simples5fb66e38469f236f34d97976",
        companiesCount: 1,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Monitoramento",
        position: 99,
        sections: [],
        sources: ["simplesNacional"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        version: 2,
        name_nd: "MONITORAMENTO",
        public: true
    },
    {
        _id: "personnel5fb66e38469f236f34d97976",
        companiesCount: 1,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Monitoramento",
        position: 99,
        sections: [],
        sources: ["personnel"],
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        version: 2,
        name_nd: "MONITORAMENTO",
        public: true
    },
    {
        _id: "9ci82ad1l55k35n950e123",
        accounting: {
            _id: "CONTABILIDADE_NUCONT",
            name: "Contabilidade Nucont"
        },
        companiesCount: 6.0,
        companyId: "EMPRESA_NUCONT",
        description: "",
        hidden: false,
        name: "Principal",
        position: 0,
        metadata: { main: true },
        sections: [
            {
                height: 50,
                template: "1,1,1",
                visualizationsIds: [
                    "CZfwFyrewkcDPSnei",
                    "CZfwFyrewkcDPSacumu",
                    "wAExJxdEoqtnFBw2n"
                ]
            },
            {
                height: 75,
                template: "1",
                visualizationsIds: ["paExJxdEoqtnFBw2n2"]
            },
            {
                height: 50,
                template: "1,1,1",
                visualizationsIds: [
                    "GLreksz7PROjAcvei",
                    "jthb2ntgka2j0ln6y0tmw",
                    "MifwFyrewkcFPUnei"
                ]
            },
            {
                height: 50,
                template: "1,1,1,1",
                visualizationsIds: [
                    "5fb6730eb8a3c0ee70996f61",
                    "nlw1jal67px1luhekn27",
                    "1ysyjjhb45bivrhoiuqe3gi",
                    "5fb3fc689f8b502f3d4b666f"
                ]
            },
            {
                height: 66,
                template: "1,1",
                visualizationsIds: [
                    "nmjfo4hiy155dw9qg7c4y",
                    "lo4uo25p2ms6ryz4llsia9"
                ]
            },
            {
                height: 50,
                template: "1,1",
                visualizationsIds: ["AcuExJxdEoqtnFBw2n", "iAExJxdEoqtnFBw2n"]
            }
        ],
        sources: ["accounting"],
        user: {
            _id: "S6cE4ebC9eLvyqapD",
            email: "contador@nucont.com",
            name: "Contabilidade Nucont"
        },
        new: true,
        version: 1.0,
        name_nd: "PRINCIPAL",
        createdAt: new Date("2021-06-15T20:28:51.627Z"),
        public: true
    }
];
